import React, { Component } from 'react';
import { Navbar, Nav, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import 'font-awesome/css/font-awesome.min.css';
import './MegaNavbar.css';

class MegaNavbar extends Component {
  render() {
    return (
      <Navbar bg="dark" variant="dark" expand="lg">
        <Navbar.Brand>
          <Link to="/"><Image responsive='true' src="./logo.png" alt="logo" fluid thumbnail/></Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="nav-links"/>
        <Navbar.Collapse id="nav-links" className="justify-content-end">
          <Nav pullright='true'>
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/product">Product</Nav.Link>
            <Nav.Link href="/about">About</Nav.Link>
            <Nav.Link href="/docs">Docs</Nav.Link>
            <Nav.Link style={{color: '#ec7211', textDecoration: 'none'}} href={this.props.isLoggedIn ? '/logout' : '/login'}>
              <FontAwesomeIcon icon={faLock} color='#ec7211' />{this.props.isLoggedIn ? ' Sign Out' : ' Sign In'}
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default MegaNavbar;